import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_play_safari",
		x1: .5,
		y1: .325,
		x2: .5,
		y2: .875,
		gradientUnits: "objectBoundingBox",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#80B344" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#5A8D1D"
		})]
	}) }), /* @__PURE__ */ _jsx("path", {
		d: "M5.83325 2.5L17.4999 10L5.83325 17.5V2.5Z",
		fill: "url(#paint0_linear_play_safari)"
	})]
});
export default SvgPlay;
